import { render, staticRenderFns } from "./RegistrosConflicto.vue?vue&type=template&id=703c4760&scoped=true&"
import script from "./RegistrosConflicto.vue?vue&type=script&lang=js&"
export * from "./RegistrosConflicto.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosConflicto.vue?vue&type=style&index=0&id=703c4760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c4760",
  null
  
)

export default component.exports